<template>
    <div>
        <hero-cards :cards="heroCards"></hero-cards>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            heroCards: [],
            pageParams: []
        };
    },

    mounted() {
        axios
            .get("/getOtherProductsPage")
            .then(response => {
                this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({ appParams: "getAppParams" })
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams"])
    }
};
</script>
